import { render, staticRenderFns } from "./BackHead.vue?vue&type=template&id=41b4d584&scoped=true&"
import script from "./BackHead.vue?vue&type=script&lang=js&"
export * from "./BackHead.vue?vue&type=script&lang=js&"
import style0 from "./BackHead.vue?vue&type=style&index=0&id=41b4d584&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b4d584",
  null
  
)

export default component.exports